module.exports = __webpack_public_path__ + "img/norway-stomach-cancer-male.63c680c3.png";